var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lazy-list-display-y',{attrs:{"nb":_vm.nb_lines,"block_rounding":1024 / 16},on:{"fetch_data":_vm.fetch_data},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var nby = ref.nby;
var height = ref.height;
return [_c('hex-viewer-line',_vm._b({key:nby,style:(height)},'hex-viewer-line',_vm.arguments_for_nb(nby),false))]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }